import * as React from 'react';

import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '5px',
    padding: '14px',
    height: '265px',
    width: '210px',
    backgroundColor: 'rgb(60, 60, 60)',
    color: 'white',
    boxShadow: '0 0 6px black',
    boxSizing: 'content-box',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgb(50,50,50)',
    height: '60px',
    width: '40px',
    boxShadow: '0 0 6px black',
  },
}));

interface INumericKeypadProps {}

const NumericKeypad: React.FC<INumericKeypadProps> = (props) => {
  const classes = useStyles();
  const onKeyPadTouch = (num: any) => {
    console.log('keypadtouch', num);
  };
  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(7)}
            className={classes.buttonContainer}
          >
            <span>7</span>
            <span>Home</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(8)}
            className={classes.buttonContainer}
          >
            <span>8</span>
            <span>
              <ArrowUpward />
            </span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(9)}
            className={classes.buttonContainer}
          >
            <span>9</span>
            <span>Up</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch('Chg')}
            className={classes.buttonContainer}
          >
            Chg
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(4)}
            className={classes.buttonContainer}
          >
            <span>4</span>
            <ArrowBack />
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(5)}
            className={classes.buttonContainer}
          >
            <span>5</span>
            <span>Supr</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(6)}
            className={classes.buttonContainer}
          >
            <span>6</span>
            <ArrowForward />
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch('+')}
            className={classes.buttonContainer}
          >
            <span>+</span>
            <span>/</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(1)}
            className={classes.buttonContainer}
          >
            <span>1</span>
            <span>End</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(2)}
            className={classes.buttonContainer}
          >
            <span>2</span>
            <ArrowDownward />
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(3)}
            className={classes.buttonContainer}
          >
            <span>3</span>
            <span>Down</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch('-')}
            className={classes.buttonContainer}
          >
            <span>-</span>
            <span>*</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch(0)}
            className={classes.buttonContainer}
          >
            <span>0</span>
            <span>Insert</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch('.')}
            className={classes.buttonContainer}
          >
            <span>.</span>
            <span>,</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch('Ctrl')}
            className={classes.buttonContainer}
          >
            <span>Ctrl</span>
            <span>Del</span>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            onClick={() => onKeyPadTouch('Enter')}
            className={classes.buttonContainer}
          >
            Enter
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NumericKeypad;
